import { PublicClientApplication } from '@azure/msal-browser';
import { loginRequest, msalConfig } from './configs';

export const msalInstance = new PublicClientApplication(msalConfig);

export const getLatestToken = async () => {
  const activeAccount =
    msalInstance.getActiveAccount() || msalInstance.getAllAccounts()[0];

  if (!activeAccount) {
    return null;
  }

  try {
    const response = await msalInstance.acquireTokenSilent({
      ...loginRequest,
      account: activeAccount,
    });
    return response;
  } catch {
    return null;
  }
};
